// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__RUC--hjx","removeIcon":"removableTag_removeIcon__XesRiPsz"};